angular.module('backOffice').controller('messageCenterController', messageCenterController);

messageCenterController.$inject = [
    '$scope',
    '$filter',
    '$modal',
    'toaster',
    'messagingCenterService',
    'navigationService',
];

function messageCenterController(
    $scope,
    $filter,
    $modal,
    toaster,
    messagingCenterService,
    navigationService
) {
    $scope.currentView = 1;
    $scope.setView = setView;
    $scope.compose = compose;
    $scope.advancedSearch = advancedSearch;
    $scope.showMessage = showMessage;
    $scope.messages = [];
    $scope.filteredMessages = [];
    $scope.filterMessages = filterMessages;
    $scope.filter = '';
    $scope.resolve = resolve;
    $scope.assign = assign;
    $scope.archive = archive;
    $scope.fromToField = 'From';
    $scope.refresh = refresh;
    $scope.cachedSearch = {};

    init();

    function init() {
        const menulessNavigationAuditId = 1;
        navigationService.menulessUserActivityAudit(menulessNavigationAuditId);
        loadMessages();
    }

    function loadMessages(searchTerms, fromSearch, currentView, silent) {
        currentView = currentView || $scope.currentView;
        if (!searchTerms) {
            searchTerms = {};
            switch (currentView) {
                case 1:
                    searchTerms.messageTypeId = 2;
                    break;
                case 2:
                    searchTerms.messageTypeId = 3;
                    break;
                case 3:
                    searchTerms.messageTypeId = 2;
                    searchTerms.assignedToUserId = -1; // BSL will replace with logged in user id
                    break;
                case 4:
                    searchTerms.messageTypeId = 4;
                    break;
                case 5:
                    searchTerms = $scope.cachedSearch.terms;
                    break;
                default:
                    break;
            }
        }
        const messageSvcCall = silent
            ? messagingCenterService.silentSearch
            : messagingCenterService.search;

        messageSvcCall(searchTerms).then(response => {
            $scope.messages = response.map(message => {
                message.companyUserName = message.isSent
                    ? message.toUserName
                    : message.fromUserName;
                return message;
            });
            $scope.filter = '';
            filterMessages();

            if (fromSearch) {
                $scope.currentView = 5;
            } else {
                $scope.currentView = currentView;
            }
            if ($scope.tableController) {
                $scope.tableController.resetSort();
            }
        });
    }

    $scope.$on('messageCountUpdated', () => {
        loadMessages(undefined, undefined, undefined, true);
    });

    function setView(view) {
        $scope.cachedSearch = {};
        loadMessages(null, null, view, false);
    }

    function refresh() {
        loadMessages();
    }

    $scope.$watch('filter', filterMessages);

    function filterMessages() {
        $scope.filteredMessages = $filter('filter')($scope.messages, filterRows);
    }

    function filterRows(row) {
        if (
            !$scope.filter ||
            $scope.filter.trim() === '' ||
            !$scope.messages ||
            $scope.messages.length <= 0
        ) {
            return true;
        }

        return (
            (row.messageId &&
                row.messageId.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1) ||
            (row.body && row.body.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1) ||
            (row.companyName &&
                row.companyName.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1) ||
            (row.companyUserName &&
                row.companyUserName.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1) ||
            (row.subject &&
                row.subject.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1) ||
            (row.sentDate &&
                row.sentDate.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1) ||
            (row.sentTime &&
                row.sentTime.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1) ||
            (row.status &&
                row.status.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1 &&
                $scope.currentView !== 2) ||
            (row.assignedTo &&
                row.assignedTo.toLowerCase().indexOf($scope.filter.toLowerCase()) !== -1 &&
                $scope.currentView !== 2)
        );
    }

    function advancedSearch() {
        const modalInstance = $modal.open({
            template: require('../views/messageCenterSearchModalView.html'),
            size: 'md',
            controller: 'messageCenterSearchModalController',
            backdrop: 'static',
            resolve: {
                cachedSearch() {
                    return $scope.cachedSearch;
                },
            },
        });
        modalInstance.result.then(response => {
            loadMessages(response.terms, true);
            $scope.cachedSearch = response;
        });
    }

    function compose() {
        const modalInstance = $modal.open({
            template: require('../views/messageCenterComposeModalView.html'),
            size: 'md',
            controller: 'messageCenterComposeModalController',
            backdrop: 'static',
        });
        modalInstance.result.then(response => {
            if (response) {
                toaster.send('Message');
                setView(1);
            }
        });
    }

    function showMessage(message) {
        if (message.status === 'New') {
            message.status = 'Open';
        }
        const modalInstance = $modal.open({
            template: require('../views/messageCenterViewModalView.html'),
            size: 'md',
            controller: 'messageCenterViewModalController',
            backdrop: 'static',
            resolve: {
                messageId() {
                    return message.id;
                },
            },
        });
        modalInstance.result.then(response => {
            if (response) {
                setView(1);
                toaster.send('Reply');
            }
        });
    }

    function resolve(message) {
        const modalInstance = $modal.open({
            template: require('../views/messageCenterResolveModalView.html'),
            size: 'md',
            controller: 'messageCenterResolveModalController',
            backdrop: 'static',
            resolve: {
                message() {
                    return message;
                },
            },
        });
        modalInstance.result.then(response => {
            message = response.message;
            toaster.save('Message');
            if (response.refresh) {
                refresh();
            }
        });
    }

    function assign(message) {
        const modalInstance = $modal.open({
            template: require('../views/messageCenterAssignModalView.html'),
            size: 'md',
            controller: 'messageCenterAssignModalController',
            backdrop: 'static',
            resolve: {
                message() {
                    return message;
                },
            },
        });
        modalInstance.result.then(response => {
            message = response;
            toaster.save('Message');
        });
    }

    function archive(message) {
        const modalInstance = $modal.open({
            template: require('../views/messageCenterArchiveModalView.html'),
            size: 'md',
            controller: 'messageCenterArchiveModalController',
            backdrop: 'static',
            resolve: {
                message() {
                    return message;
                },
            },
        });
        modalInstance.result.then(response => {
            message = response;
            toaster.save('Message');
            refresh();
        });
    }
}
